import { tvpil } from '../compat/tvpil';
import { createMissingCategoryError } from '../errors';

import { fetchLastWatchedQuery } from './queries';
import { LastWatched } from './types';
import { createLastWatched } from './utils';

type FetchLastWatchedArgs = {
  referenceId: string;
  pageReferenceId: string;
};

export async function fetchLastWatched({
  pageReferenceId,
  referenceId,
}: FetchLastWatchedArgs): Promise<LastWatched | undefined> {
  const category = tvpil.categoryTreeItemsMap.get(referenceId);

  if (!category) {
    throw createMissingCategoryError();
  }

  const lastWatchedData = await fetchLastWatchedQuery();

  if (lastWatchedData) {
    return createLastWatched({
      defaultChannelId: category.railProperty.defaultChannel,
      lastWatchedData,
      pageReferenceId,
    });
  }
}
